import React, { useState } from "react";
import axiosService from "../../../../helpers/axios";


export function Examview({exam}){
    const [notification, setNotification] = useState()

    function Notificate(message) {
        setNotification(message);
        setTimeout(() => {
        setNotification("");
        }, 2500);
    }

    function deleteBeat(beat_id){
        axiosService.delete(`https://beatsapi.ilemlembo.me/api/creator/Beat/${beat_id}/`)
            .then((res)=> {
                Notificate("Beat Deleted Successfully!")
            })
            .catch((error) => console.error("Error deleting Beat: ", error))
    }
    return(
        <li className="exam--item" key={exam.id}>
        
            {notification && <div className="notification"><p>{notification} </p><div onClick={()=>setNotification("")} className="closebtn"><i className="fa-solid fa-xmark"></i></div></div>}

            <div className="exam--info">

                <h2>Title : {exam.title}</h2>
                <p>Date Posted :{exam.date_created}</p>
                <p>file : {exam.file}</p>

            </div>

            <h2 className="exam--code" onClick={() => deleteBeat(exam.id)}> <i class="fa-solid fa-trash"></i></h2>
        </li>
    )
}